<template>
  <div>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.busCls" :label="filtersLabel.busCls" :error-messages="errors.collect('busCls')" data-vv-name="busCls" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.busClsDesc" :label="filtersLabel.busClsDesc" :error-messages="errors.collect('busClsDesc')" data-vv-name="busClsDesc" :data-vv-as="filtersLabel.busClsDesc" v-validate="'entry|max:40'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="tariffList" v-model="filters.defTariff" :label="filtersLabel.defTariff" item-text="label" item-value="value" data-vv-name="defTariff" :data-vv-as="filtersLabel.defTariff" :error-messages="errors.collect('defTariff')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.perGst" :label="filtersLabel.perGst" item-text="label" item-value="value" data-vv-name="perGst" :data-vv-as="filtersLabel.perGst" :error-messages="errors.collect('perGst')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="busClsAppList" v-model="filters.busClsAppId" :label="filtersLabel.busClsAppId" item-text="label" item-value="value" data-vv-name="busClsAppId" :data-vv-as="filtersLabel.busClsAppId" :error-messages="errors.collect('busClsAppId')" clearable></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="busCls" :loading="loading" :no-data-text="noDataText">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.busCls }} - {{ props.item.desc }}</td>
              <td class="text-xs-left">{{ props.item.defTariffDesc }}</td>
              <td class="text-xs-left">{{ formatBoolean(props.item.perGst) }}</td>
              <td class="text-xs-left">{{ props.item.busClsAppId }}</td>
              <td class="text-xs-right">
                <table-action :rowData="props" remove review @review="doReview" @remove="doPromptRemove(props.item)"></table-action>
              </td>
            </template>
          </v-data-table>
          <div class="pt-2">
            <v-btn color="primary" @click='doNewBusCls'>
              New Package Business Class
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </div>
          <confirm v-model="promptRemove" @ok="doRemove">
            Are you sure that you want to delete the selected Business Class?
            <div class="title">{{deleteBusCls}}</div>
          </confirm>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { mapGetters } from 'vuex'
import { appID, busClsAppID } from '@/const/underwriting'
import { PARAMETERS_APPID, BUSCLS_INIT_LIST } from '@/store/types'
import { filterQuery, expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Business Class', value: 'busCls' },
        { text: 'Default Tariff', value: 'defTariffDesc' },
        { text: 'Permitted GST', value: 'perGst' },
        { text: 'Business Class AppID', value: 'busClsAppId' },
        TableConst.tableActionHeader
      ],
      filtersLabel: {
        busCls: 'Business Class',
        busClsDesc: 'Business Class Description',
        defTariff: 'Default Tariff',
        perGst: 'Permitted GST',
        busClsAppId: 'Business Class AppID'
      },
      filters: {
        busCls: null,
        busClsDesc: null,
        defTariff: null,
        perGst: null,
        vehGrp: null,
        busClsAppId: null
      },
      busClsForm: {
        busCls: null,
        busClsDesc: null,
        defTariff: null,
        perGst: null,
        vehGrp: null
      },
      loading: null,
      totalItems: 0,
      booleanList: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      vehGrpList: [],
      tariffList: [],
      deleteBusCls: '',
      promptRemove: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    constAppID() {
      return appID
    },
    appID() {
      return this.$store.state.parameters.appID
    },
    busClsAppList() {
      const list = Object.freeze(busClsAppID)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.$store.state.parameters.busCls.menu.busClses
      const { page, rowsPerPage } = this.pagination
      let expand = {
        appId: this.appID,
        page: page - 1,
        size: rowsPerPage
      }
      if (apiURI) {
        const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
        this.loading = true
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          this.vehGrpList = result.data.vehGrpList
          this.tariffList = result.data.tariffList
          if (data) {
            this.items = []
            data.map((busCls) => {
              const convertBusCls = {
                busCls: busCls.busCls,
                defTariff: busCls.defTariff,
                defTariffDesc: busCls.defTariffDesc,
                desc: busCls.desc,
                perGst: busCls.perGst,
                perStp: busCls.perStp,
                perTonnage: busCls.perTonnage,
                vehGrp: busCls.vehGrp,
                vehGrpDesc: busCls.vehGrpDesc,
                busClsAppId: busCls.busClsAppId
              }
              this.items.push(convertBusCls)
            })
            this.$store.commit(BUSCLS_INIT_LIST, result.data)
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - List Business Class')
      }
    },
    doClearFilters() {
      this.filters.busCls = null
      this.filters.busClsDesc = null
      this.filters.defTariff = null
      this.filters.perGst = null
      this.filters.perStp = null
      this.filters.perTonnage = null
      this.filters.vehGrp = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doReview(data) {
      switch (data.item.busClsAppId) {
        case 'MO': {
          this.$router.push({ name: 'motorBusClsGeneral', params: { id: data.item.busCls } })
          break
        }
        case 'TR': {
          this.$router.push({ name: 'travelBusClsGeneral', params: { id: data.item.busCls } })
          break
        }
        case 'CA': {
          this.$router.push({ name: 'cargoBusClsGeneral', params: { id: data.item.busCls } })
          break
        }
        default: {
          this.$router.push({ name: 'packageBusClsGeneral', params: { id: data.item.busCls } })
          break
        }
      }
    },
    doNewBusCls() {
      this.$router.push({ name: 'packageBusClsGeneral', params: { id: 'new' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedBusCls = data
        this.deleteBusCls = data.busCls + ' - ' + data.desc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.parameters.busCls.menu.busClsDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          busCls: this.selectedBusCls.busCls
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData(true)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Business Class')
      }
    }
  },
  mounted() {
    this.$store.commit(PARAMETERS_APPID, this.constAppID.PACKAGE)
    Promise.all([this.fetchData(true)])
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
